const getTemplates = state => state.templates;
const getTemplate = state => state.template;
const getMeta = state => state.meta;

export default {
    getTemplates,
    getTemplate,
    getMeta,
}
